const SAVE = 'SAVE_PRODUCT';

export function productReducer (state = [], action) {
    switch (action.type) {
        case SAVE:
            return action.payload;
        default:
            return state;
    }
}